// @ts-nocheck
import validatePhone from "@insite/client-framework/Common/Utilities/validatePhone";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import TextFormField, {
    TextFormFieldPresentationProps,
    TextFormFieldProps,
} from "@store/Library/Components/FormField/TextFormField";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";

export const phoneNumberFormFieldLabelKey = "Phone Number";

export interface PhoneNumberFormFieldPresentationProps extends ExpandStyles<PhoneNumberFormFieldStyles> {}

export interface PhoneNumberFormFieldProps
    extends Omit<TextFormFieldProps, keyof TextFormFieldPresentationProps>,
        PhoneNumberFormFieldPresentationProps {}

export interface PhoneNumberFormFieldStyles {
    textFormField?: TextFormFieldPresentationProps;
}

export const phoneNumberFormFieldStyles: PhoneNumberFormFieldStyles = {};

const PhoneNumberFormField: FC<PhoneNumberFormFieldProps> = ({
    extendedStyles,
    onValidate,
    overridedStyles,
    ...textFormFieldProps
}) => {
    const styles = useExpandProps(phoneNumberFormFieldStyles, extendedStyles, overridedStyles);

    const validate: typeof onValidate = ({ isValid, value }) => {
        if (!isValid) {
            return;
        }

        let errorMessage: string | undefined;

        if (value && !validatePhone(value)) {
            errorMessage = siteMessage("ContactUsForm_PhoneNumberIsInvalidErrorMessage").toString();
        }

        errorMessage = onValidate?.({ isValid: !errorMessage, value }) ?? errorMessage;

        return errorMessage;
    };

    return (
        <TextFormField
            {...styles.textFormField}
            label={translate(`${phoneNumberFormFieldLabelKey}`)}
            placeholder={translate("(###) ###-####")}
            {...textFormFieldProps}
            onValidate={validate}
        />
    );
};

export default PhoneNumberFormField;
